import { useTranslation } from "react-i18next";
import { Badge } from "components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

export const BetaBadge = () => {
  const { t } = useTranslation("components");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Badge
            className="ml-2 px-2 py-0.5 text-xs font-medium leading-tight border-0 bg-system-warning text-white"
            data-testid="beta-badge"
          >
            {t("components:betaBadge.label")}
          </Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent className="font-normal">
        {t("components:betaBadge.tooltip")}
      </TooltipContent>
    </Tooltip>
  );
};
